import { Api, IApiResponse } from '../api';
import { ConfigurationDto } from '../models';

export const get = (signal?: AbortSignal, accessToken?: string): Promise<IApiResponse<ConfigurationDto>> =>
    Api.get('Configuration', signal, accessToken);

export const update = (configuration: ConfigurationDto, signal?: AbortSignal) => Api.put('Configuration', configuration, signal);
